/* eslint-disable */
import React from "react";
import { ProfessionalBenefits } from "./partials";

export default class ProductManager extends React.Component {
  render () {
    return (
      <div className="container page-container">
        <div className="card">
          <h2 style={{ marginBottom: 20, textAlign: "center" }}>Account Executive - Denver, CO</h2>

          <h4>About Haven Connect</h4>
          <p style={{ fontSize: 15 }}>
            Haven Connect transforms the affordable housing industry by streamlining the application
            process for residents and property managers. Haven Connect uses automation and a deep
            understanding of the regulatory challenges for affordable housing to get low-income
            Americans into units faster {"&"} at a fraction of the cost.
          </p>

          <h4 style={{ marginTop: 40 }}>About You</h4>
          <p style={{ fontSize: 15 }}>
            You care deeply about both improving the lives of Americans with low income and building
            a real, profitable business. You are energetic, yet composed. Personable. A tenacious
            self-starter. Superb at time management, diplomatic and committed to transparent
            communication. You thrive in an atmosphere where the intern’s ideas are given as much
            respect at the executive management. The spirit of the entrepreneur is strong in
            you---you relish taking the initiative and leading projects. You are driven by a need to
            leave things better than you found them.
          </p>

          <h4 style={{ marginTop: 40 }}>What you'll do</h4>
          <p style={{ fontSize: 15 }}>
            <li>
              Carry and excel against a personal quota in a full cycle sales - creating & developing
              your own pipeline and closing deals
            </li>
            <li>
              Create targeted and thoughtful email/phone campaigns and messaging; be constantly
              improving upon our various pitches
            </li>
            <li>
              Thoroughly understand and articulate Haven Connect’s value propositions to prospects
            </li>
            <li>
              Become an industry and product expert to effectively conduct product demos to
              prospects; keep abreast of competition, competitive issues, and products
            </li>
            <li>
              Act as a strategic partner and trusted advisor to our prospects & customers while
              challenging existing thinking.
            </li>
            <li>
              Work closely with VP of Sales on various projects and initiatives; contribute to the
              evolving strategy of our business.
            </li>
            <li>Work in conjunction with the Success team to ensure customer satisfaction</li>
            <li>
              Regularly communicate market feedback to internal stakeholders to improve the product
              experience
            </li>
            <li>
              Use Salesforce to manage customer interactions, the sales process, and reporting
            </li>
            <li>Travel to customer locations when required</li>
          </p>

          <h4 style={{ marginTop: 40 }}>Required Skills and Experience</h4>
          <p style={{ fontSize: 15 }}>
            <li>
              3+ years as an Account Executive, ideally selling a SaaS technology or enterprise
              software solution
            </li>
            <li>BA or BS degree or equivalent experience</li>
            <li>Experience selling to C-suite, especially operations executives</li>
            <li>Focus on helping prospects, with strong empathy and low judgement</li>
            <li>
              Excellent interpersonal and communication skills, presentation and writing skills
            </li>
            <li>
              Ability to think at both the 50,000 foot-level (how the parts make the whole) and the
              5 foot-level (how each part works).
            </li>
            <li>You are a self-starter who consistently exceed expectations</li>
            <li>
              Strongly proficient with sales tools, including Salesforce, Outreach, and G-suite
            </li>
            <li>Background with tax-credit or HUD affordable housing regulations a plus</li>
          </p>

          <ProfessionalBenefits />

          <p style={{ fontSize: 15 }}>
            Please email resume or LinkedIn profile to{" "}
            <a href="mailto:hiring@havenconnect.com">hiring@havenconnect.com</a>
          </p>
        </div>
      </div>
    );
  }
}
